import { render, staticRenderFns } from "./PlainRouterViewWithBack.vue?vue&type=template&id=9809c3ca"
import script from "./PlainRouterViewWithBack.vue?vue&type=script&lang=js"
export * from "./PlainRouterViewWithBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9809c3ca')) {
      api.createRecord('9809c3ca', component.options)
    } else {
      api.reload('9809c3ca', component.options)
    }
    module.hot.accept("./PlainRouterViewWithBack.vue?vue&type=template&id=9809c3ca", function () {
      api.rerender('9809c3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PlainRouterViewWithBack.vue"
export default component.exports